<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <table class="c-indicator c-indicator-w-100">
      <thead>
        <tr>
          <th class="tab-wid-80">№<br /></th>
          <th class="tab-wid-80">Группа</th>
          <th class="tab-wid-122">
            Код оборудования
          </th>
          <th class="tab-wid-250">
            Вид оборудования
          </th>
          <th>
            Наименование закупаемого оборудования
          </th>
          <th>
            Количество
          </th>
          <th class="tab-wid-80"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in $parent.project.PURCHASED_EQUIPMENT.items">
          <td class="tab-wid-80">{{ index + 1 }}</td>
          <td class="tab-wid-80">
            {{ medName(item.UF_VID_GROUP_ID) }}
          </td>
          <td class="tab-wid-80">
            {{ groupCode(item.UF_VID_GROUP_ID, item.UF_VID_ID) }}
          </td>
          <td class="tab-wid-80">
            {{ groupName(item.UF_VID_GROUP_ID, item.UF_VID_ID) }}
          </td>
          <td class="tab-wid-80">{{ item.UF_DESCRIPTION }}</td>
          <td class="tab-wid-80">
            <span v-if="item.UF_COUNT_FROM !== item.UF_COUNT_TO"
              >от {{ item.UF_COUNT_FROM }} до {{ item.UF_COUNT_TO }}</span
            >
            <span v-else>{{ item.UF_COUNT_FROM }}</span>
          </td>
          <td
            v-if="
              !$parent.$parent.projectDisabled &&
                !$parent.project.UF_IS_BLOCK &&
                $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1
            "
          >
            <i class="i-edit centerIcon" @click="editItem(index)"></i>
            <i
              class="i-delete centerIcon"
              title="Удалить запись"
              @click="deleteItem(index)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div
      class="add-row"
      v-show="
        !$parent.$parent.projectDisabled &&
          !$parent.project.UF_IS_BLOCK &&
          $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1
      "
    >
      <a class="link-add-row" @click="showAddItem">Добавить</a>
    </div>
    <div
      class="modal fade in"
      v-bind:class="{ show: showForm }"
      v-if="showForm"
      tabindex="-1"
      role="dialog"
    >
      <form v-on:submit.prevent="submit">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                @click="showForm = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                {{ Object.keys(item).length > 0 ? "Изменить" : "Добавить" }}
                позицию
              </h4>
            </div>
            <div class="modal-body">
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_VID_GROUP_ID') }"
              >
                <label>Группа<span>*</span></label>
                <select v-model="item.UF_VID_GROUP_ID" class="form-control">
                  <option
                    v-for="item in cGroupStartSelect"
                    v-bind:value="item.ID"
                    v-bind:key="item.ID"
                    v-text="item.NAME"
                  ></option>
                </select>
              </div>
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_VID_ID') }"
              >
                <label>Вид оборудования<span>*</span></label>
                <select v-model="item.UF_VID_ID" class="form-control">
                  <option
                    v-for="item in cGroup"
                    v-bind:value="item.ID"
                    v-bind:key="item.ID"
                    v-text="item.NAME"
                  ></option>
                </select>
              </div>
              <div
                class="form-group"
                v-bind:class="{
                  'has-error': checkError('UF_DESCRIPTION')
                }"
              >
                <label>Наименование<span>*</span></label>
                <input
                  type="text"
                  maxlength="200"
                  class="form-control"
                  v-model="item.UF_DESCRIPTION"
                />
              </div>
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_COUNT_FROM') }"
              >
                <label>Количество<span>*</span></label>
                <div class="clear"></div>
                <input
                  type="text"
                  placeholder="от"
                  style="display: inline;width: auto"
                  class="form-control"
                  v-model="item.UF_COUNT_FROM"
                  @keypress="isNumber($event)"
                />
                <input
                  type="text"
                  placeholder="до"
                  style="display: inline;width: auto"
                  class="form-control"
                  v-model="item.UF_COUNT_TO"
                  @keypress="isNumber($event)"
                />
              </div>
              <button type="button" @click="submit" class="btn btn-info">
                Сохранить
              </button>
              <button
                type="button"
                @click="showForm = false"
                class="btn btn-default btn-style-big"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "EquipmentMarkirovka",
  data() {
    return {
      showForm: false,
      editIndex: 0,
      item: {
        UF_VID_GROUP_ID: 0
      },
      errorFields: {}
    };
  },
  created() {
    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]);
    this.$store.dispatch(FETCH_DIRECTORY, ["tree/group_med_oborudovanie"]);
  },
  computed: {
    ...mapGetters(["directory"]),

    cGroupStartSelect() {
      //#79664
      let t = [];
      t = this.directory.tree_group_med_oborudovanie.filter(
        c =>
          c.UF_IS_SET_BLOCK_FIELD === 0 &&
          c.UF_SUPPORT_PROGRAM_ID.indexOf(
            this.$parent.project.UF_SUPPORT_PROG_ID
          ) >= 0
      );

      let list = [];
      t.forEach(function(el) {
        let ver = 1;
        if (
          this.programCode(this.$parent.project.UF_SUPPORT_PROG_ID) ===
          "lekarstva"
        ) {
          ver = 2;
        }

        if (el.CHILD) {
          let ch = el.CHILD.filter(
            c =>
              c.VERSION === ver &&
              c.INDUSTRY.indexOf(this.$parent.project.UF_INDUSTRY_ID) >= 0
          );

          if (ch.length > 0) {
            list.push(el);
          }
        }
      }, this);

      return list;
    },

    cGroup() {
      if (this.item.UF_VID_GROUP_ID < 1) {
        return [];
      }
      let t = null;
      t = this.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === this.item.UF_VID_GROUP_ID
      );
      if (t[0]) {
        let ver = 1;
        if (
          this.programCode(this.$parent.project.UF_SUPPORT_PROG_ID) ===
          "lekarstva"
        ) {
          ver = 2;
        }
        let ch = t[0].CHILD.filter(
          c =>
            c.VERSION === ver &&
            c.INDUSTRY.indexOf(this.$parent.project.UF_INDUSTRY_ID) >= 0
        );
        return ch;
      }
      return [];
    },
    purchasedEquipment() {
      let t = this.directory.tree_industry.filter(
        c => c.ID === this.$parent.project.UF_INDUSTRY_ID
      );
      if (t.length > 0) {
        console.log(
          "this.$parent.directory.tree_group_med_oborudovanie: ",
          JSON.parse(
            JSON.stringify(this.$parent.directory.tree_group_med_oborudovanie)
          )
        );
        return t[0].CODE;
      }
      return [];
    }
  },
  methods: {
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID == id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    },
    showAddItem() {
      this.setError("");
      this.showForm = true;
      this.editIndex = -1;
      this.item = {};
    },
    editItem(index) {
      this.setError("");
      this.editIndex = index;
      this.item = JSON.parse(
        JSON.stringify(this.$parent.project.PURCHASED_EQUIPMENT.items[index])
      );
      this.showForm = true;
    },
    deleteItem(index) {
      this.$parent.project.PURCHASED_EQUIPMENT.items.splice(index, 1);
    },
    submit() {
      this.setError("");
      if (!this.item.UF_DESCRIPTION) {
        this.setError("UF_DESCRIPTION");
      }
      if (!this.item.UF_VID_GROUP_ID) {
        this.setError("UF_VID_GROUP_ID");
      }
      if (!this.item.UF_VID_ID) {
        this.setError("UF_VID_ID");
      }
      if (
        !this.item.UF_COUNT_FROM ||
        !this.item.UF_COUNT_TO ||
        parseFloat(this.item.UF_COUNT_FROM) > parseFloat(this.item.UF_COUNT_TO)
      ) {
        this.setError("UF_COUNT_FROM");
      }
      if (Object.keys(this.errorFields).length) {
        return;
      }
      if (this.editIndex > -1) {
        this.$parent.project.PURCHASED_EQUIPMENT.items[
          this.editIndex
        ] = JSON.parse(JSON.stringify(this.item));
      } else {
        this.$parent.project.PURCHASED_EQUIPMENT.items.push(this.item);
      }
      this.showForm = false;
      return false;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setError(field, val) {
      if (!field) {
        this.errorFields = {};
        return;
      }
      this.errorFields[field] = val ? val : true;
    },
    checkError(field) {
      if (this.errorFields[field]) {
        return true;
      }
      return false;
    },
    medName(item) {
      const result = this.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === item
      );
      if (!result.length) {
        return "";
      }
      return result[0].NAME;
    },
    groupCode(item, group) {
      const result = this.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === item
      );
      if (!result.length) {
        return "";
      }
      const vid = result[0].CHILD.filter(c => c.ID === group);
      console.log(vid);
      if (!vid.length) {
        return "";
      }
      return vid[0].CODE;
    },
    groupName(item, group) {
      const result = this.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === item
      );
      if (!result.length) {
        return "";
      }
      const vid = result[0].CHILD.filter(c => c.ID === group);
      console.log(vid);
      if (!vid.length) {
        return "";
      }
      return vid[0].NAME;
    }
  }
};
</script>

<style scoped></style>
